<template>
  <div class="dft-title_text">
    <div class="attr-item-box" v-for="(item,index) in value.attrsort" :key="index">
      <div class="attr-item-typedata" v-if="item == 'a1'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-input placeholder="请输入公告内容" v-model="value.attr[item].value"></el-input>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a3'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">跟随全局</el-radio-button>
            <el-radio-button label="2">自定义</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a4' && value.attr['a3'].value == '2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a7'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="0">直角</el-radio-button>
            <el-radio-button label="8px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle " v-else-if="item == 'a8'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="0">无边</el-radio-button>
            <el-radio-button label="6px">有边</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a9','a10'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-slider v-model="value.attr[item].value" :min="value.attr[item].min" :max="value.attr[item].max"
            show-input :show-input-controls="false" class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a2','a5','a6'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return { attr: {}, attrsort: [] }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        {
          attr: {
            a1: {
              label: '公告',
              value: '',
              sid: 'attr_s1',
              key: 'text',
              type: 'data',
              tag: 'input'
            },
            a2: {
              label: '背景颜色',
              value: '#ffffff',
              sid: 'attr_s2',
              showList: {},
              default: '#ffffff',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a3: {
              label: '图标颜色',
              value: '1',
              sid: 'attr_s3',
              showList: {
                '1': '跟随全局',
                '2': '自定义'
              },
              key: 'logo-background',
              type: 'style',
              tag: 'radio'
            },
            a4: {
              label: '图标颜色',
              value: '#323233',
              sid: 'attr_s',
              showList: {},
              default: '#323233',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a5: {
              label: '文字颜色',
              value: '#323233',
              sid: 'attr_s',
              showList: {},
              default: '#323233',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a6: {
              label: '卡片背景',
              value: '#ffffff',
              sid: 'attr_s',
              showList: {},
              default: '#ffffff',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a7: {
              label: '卡片倒角',
              value: '8px',
              sid: 'attr_s3',
              showList: {
                '0': '直角',
                '8px': '圆角'
              },
              key: 'border-radius',
              type: 'style',
              tag: 'radio'
            },
            a8: {
              label: '上下边距',
              value: '4px',
              sid: 'attr_s3',
              showList: {
                '0': '无边',
                '4px': '有边'
              },
              key: 'logo-background',
              type: 'style',
              tag: 'radio'
            },
            a9: {
              label: '页面边距',
              value: 16,
              sid: 'attr_s5',
              min: 0,
              max: 30,
              key: 'padding',
              type: 'style',
              tag: 'el-slider'
            },
            a10: {
              label: '高度',
              value: 36,
              sid: 'attr_s5',
              min: 20,
              max: 50,
              key: 'padding',
              type: 'style',
              tag: 'el-slider'
            }
          },
          attrsort: [
            'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a10', 'a7', 'a8', 'a9', 'a10'
          ]
        }
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
// 说明注释
.info-setby{
  position: relative;
  padding-bottom: 12px;
}
.info-set{
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
</style>
